"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var Switcher = function Switcher(_ref) {
  var disable = _ref.disable,
      on = _ref.on,
      onChange = _ref.onChange,
      label = _ref.label,
      meta = _ref.meta,
      _ref$customClass = _ref.customClass,
      customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
      _ref$labelCustomClass = _ref.labelCustomClass,
      labelCustomClass = _ref$labelCustomClass === void 0 ? '' : _ref$labelCustomClass,
      ControlSwitcherProps = _ref.ControlSwitcherProps;
  return (0, _preact.h)("label", {
    className: "".concat(customClass, " font-weight-normal preact-switch switcher").concat(disable ? ' disable' : '')
  }, (0, _preact.h)("div", (0, _extends2.default)({}, ControlSwitcherProps, {
    className: (0, _classnames.default)(ControlSwitcherProps === null || ControlSwitcherProps === void 0 ? void 0 : ControlSwitcherProps.className, 'control-switcher', {
      on: Boolean(on)
    })
  }), (0, _preact.h)("a", {
    className: "toggle",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onChange();
    },
    href: "#"
  }, (0, _preact.h)("i", {
    className: "icon-handler"
  })), (0, _preact.h)("a", {
    className: "ui-on",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onChange();
    },
    href: "#"
  }, (0, _preact.h)("i", {
    className: "icon-check-slim"
  })), (0, _preact.h)("a", {
    className: "ui-off",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onChange();
    },
    href: "#"
  }, (0, _preact.h)("i", {
    className: "icon-cross-slim"
  }))), (0, _preact.h)("div", {
    className: "".concat(labelCustomClass)
  }, label), meta && (0, _preact.h)("div", {
    className: "metadata"
  }, meta));
};

var _default = Switcher;
exports.default = _default;